export const configurableSections = [
	'personal/basic','personal/emergency','personal/SSN','personal/gender',
	'travel/passport','travel/visaform','travel/visadocs','travel/visastatus',
	'field/registered','field/GSCE','field/browse','field/checkout',
	'shuttles',
	'financial/fieldpayment','financial/programfeepayment','financial/financialaid','financial/insurance',
	'academic/basic','academic/EID','academic/transcriptstatus','academic/transcriptaddress',
	'health/medicalhistory','health/vaccinations','health/allergies','health/dietary','health/info','health/special',
	'agreements',
	'cabin/type','cabin/gender','cabin/roommates', 
	'admissions/academic', 'admissions/signatory', 'safety/medicalcapabilityreports', 'field/cancel-fee-disabled'
];

export const undisableableSections = [
	'travel/visaform','travel/visadocs',
	'shuttles',
	'academic/EID','academic/transcriptstatus','academic/transcriptaddress',
	'agreements',
	'health/medicalhistory','health/info',
	'cabin/type',
];



// WEBPACK FOOTER //
// ./portal-components/Portal/AdminConfig/sections.js